const generateErrorString = (...keys: any) => {
  if (!(keys.length > 0))
    throw new Error('QAL Error: generateErrorString requires at least one key');

  return [keys].reduce((str, item) => `${str} , ${item}`);
};

export default generateErrorString;
